<template>
<section class="contact-section">
  <div class="container">
    <div class="contact-container">
      <!-- Kontaktinformation -->
      <div class="contact-info">
        <h2>Kontakta oss</h2>
        <div class="info-box">
          <div class="icon">
            <img src="/assets/phone-icon.svg" />
          </div>
          <p>070-736 88 99</p>
        </div>
        <div class="info-box">
          <div class="icon">
            <img src="/assets/mail-icon.svg" />
          </div>
          <p>info@theloungebar.se</p>
        </div>
        <div class="info-box">
          <div class="icon">
            <img src="/assets/pin-icon.svg" />
          </div>
          <p>Sveavägen 45<br>Stockholm</p>
        </div>
          <h2 class="mt-5">Öppettider</h2>
          <p class="info-note">
          Måndag till Torsdag 14:00 - 01:00
          </p>
          <p class="info-note">
          Fredag 12:00-01:00
          </p>
          <p class="info-note">
            Lördag 11:00-01:00
          </p>

          <p class="info-note">
          Söndag 12:00-01:00
          </p>
        
      </div>

      <!-- Kontaktformulär -->
      <div class="contact-form">
        <h2>Hur kan vi hjälpa dig?</h2>
        <form @submit.prevent="sendMessage">
          <input
            type="text"
            v-model="name"
            placeholder="Ditt namn"
            :class="{ 'error-field': !name.trim() && triedToSubmit }"
            required
          />
          <span v-if="!name.trim() && triedToSubmit" class="error-message">Namn är obligatoriskt.</span>

          <input
            type="email"
            v-model="email"
            placeholder="Din email"
            :class="{ 'error-field': (!email.trim() || !/\S+@\S+\.\S+/.test(email)) && triedToSubmit }"
            required
          />
          <span v-if="(!email.trim() || !/\S+@\S+\.\S+/.test(email)) && triedToSubmit" class="error-message">Ange en giltig e-postadress.</span>

          <input
            type="text"
            v-model="subject"
            placeholder="Ämne"
            :class="{ 'error-field': !subject.trim() && triedToSubmit }"
            required
          />
          <span v-if="!subject.trim() && triedToSubmit" class="error-message">Ämne är obligatoriskt.</span>

          <textarea
            v-model="message"
            placeholder="Skriv ditt meddelande här..."
            :class="{ 'error-field': !message.trim() && triedToSubmit }"
            required
          ></textarea>
          <span v-if="!message.trim() && triedToSubmit" class="error-message">Meddelande är obligatoriskt.</span>

          <button type="submit">Skicka</button>

          <div v-if="validation" :class="['validation-message', isSuccess ? 'success-message' : 'error-message']">
            {{ validation }}
          </div>
        </form>


      </div>
    </div>
  </div>
</section>


</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      name: "",
      email: "",
      subject: "",
      message: "",
      triedToSubmit: false,
      validation: "", // För att lagra valideringsmeddelanden
      isSuccess: false // För att hantera meddelandets färg
    };
  },
  methods: {
    validateForm() {
      if (!this.name.trim()) {
        this.validation = "Namn är obligatoriskt.";
        this.isSuccess = false;
        return false;
      }
      if (!this.email.trim() || !/\S+@\S+\.\S+/.test(this.email)) {
        this.validation = "Ange en giltig e-postadress.";
        this.isSuccess = false;
        return false;
      }
      if (!this.subject.trim()) {
        this.validation = "Ämne är obligatoriskt.";
        this.isSuccess = false;
        return false;
      }
      if (!this.message.trim()) {
        this.validation = "Meddelande är obligatoriskt.";
        this.isSuccess = false;
        return false;
      }
      this.validation = ""; // Rensa valideringsmeddelande
      return true;
    },
    async sendMessage() {
      if (!this.validateForm()) {
        return;
      }

      try {
        await axios.post("https://theloungebar.se/send-email.php", {
          name: this.name,
          email: this.email,
          subject: this.subject,
          message: this.message
        });

        this.validation = "Ditt meddelande har skickats!";
        this.isSuccess = true; // Grönt meddelande
        this.name = "";
        this.email = "";
        this.subject = "";
        this.message = "";
      } catch (error) {
        console.error("Kunde inte skicka meddelandet:", error);
        if (error.response && error.response.status === 400) {
          this.validation = "Kunde inte skicka e-post: Alla fält är obligatoriska.";
        } else if (error.response && error.response.status === 500) {
          this.validation = "Ett serverfel inträffade. Försök igen senare.";
        } else {
          this.validation = "Något gick fel. Försök igen senare.";
        }
        this.isSuccess = false; // Rött meddelande
      }
    }
  }
};
</script>




<style>

.validation-message {
  font-size: 1rem;
  margin-top: 1rem;
  text-align: center;
  padding: 0.5rem;
  border-radius: 5px;
}

.success-message {
  color: #155724;
  background-color: #d4edda;
  border: 1px solid #c3e6cb;
}

.error-message {
  color: #721c24;
  background-color: #f8d7da;
  border: 1px solid #f5c6cb;
}


/* Sektionens stil */
.contact-section {
  background-color: #000; /* Mörk bakgrund */
  color: #F5F5F5; /* Ljus text */
  padding: 10rem 2rem;
  font-family: 'Lato', sans-serif;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
}

.contact-container {
  display: flex;
  flex-wrap: wrap;
  gap: 2rem;
  justify-content: space-between;
}

/* Kontaktinfo */
.contact-info {
  flex: 1;
  min-width: 300px;
}

.contact-info h2 {
  font-size: 1.8rem;
  color: #937d51; /* Guldfärg */
  margin-bottom: 1.5rem;
}

.info-box {
  display: flex;
  align-items: center;
  margin-bottom: 1rem;
}

.icon {
  background-color: #937d51; /* Guldfärgad ikon */
  color: #1A1A1A; /* Kontrastfärg */
  width: 50px;
  height: 50px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 1rem;
}

.info-box p {
  margin: 0;
  font-size: 1rem;
}

.info-note {
  margin-top: 1rem;
  font-size: 0.9rem;
  color: #B5B5B5; /* Ljusare text */
}

/* Kontaktformulär */
.contact-form {
  flex: 1;
  min-width: 300px;
}

.contact-form h2 {
  font-size: 1.8rem;
  color: #937d51; /* Guldfärg */
  margin-bottom: 1.5rem;
}

.contact-form form {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.contact-form input,
.contact-form textarea {
  width: 100%;
  padding: 0.8rem;
  border-radius: 5px;
  background-color: #292929; /* Mörkare grå */
  color: #F5F5F5;
  font-size: 1rem;
  border: none;
}

.contact-form input::placeholder,
.contact-form textarea::placeholder {
  color: #B5B5B5;
}

.contact-form textarea {
  height: 120px;
  resize: none;
}

.contact-form button {
  background-color: #937d51;
  color: #1A1A1A;
  padding: 0.8rem 1.5rem;
  border: none;
  border-radius: 5px;
  font-size: 1rem;
  font-weight: bold;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.contact-form button:hover {
  background-color: #FFF; /* Ljusare guldfärg */
}

/* Form-checkbox */
.form-checkbox {
  font-size: 0.9rem;
  color: #B5B5B5;
}

.form-checkbox input {
  margin-right: 0.5rem;
}

/* Responsivitet */
@media (max-width: 768px) {
  .contact-container {
    flex-direction: column;
    align-items: center;
  }

  .contact-info, .contact-form {
    max-width: 100%;
    text-align: center;
  }

  .info-box {
    justify-content: center;
  }

  .info-box p {
    text-align: center;
  }
}
</style>
